"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var FolderTree_1 = require("components/FolderTree");
var constants_1 = require("components/FolderTree/constants");
exports.default = (function (props) { return (React.createElement("div", null,
    React.createElement("div", { className: 'disclaimer' },
        React.createElement("div", null, (0, translation_1.getLocalization)('congrid/link/wizard/step1/disclaimer'))),
    props.tree && props.currentProject && (React.createElement(FolderTree_1.default, { parentIdentifier: props.currentProject.rootFolderIdentifier, tree: props.tree, selectItem: function (file, value) {
            var item = file.getValue();
            if (item && item.type !== 'FOLDER') {
                if (value === true &&
                    props.linkedFiles.findIndex(function (x) { return x.fileUuid === item.fileUuid; }) === -1) {
                    props.selectItem(file, value);
                }
                else {
                    props.addToast((0, translation_1.getLocalization)('congrid/link/alreadyLinked/title'), (0, translation_1.getLocalization)('congrid/link/alreadyLinked/message'));
                }
            }
        }, changeExpand: props.changeExpand, getContent: props.getContent, expandType: constants_1.ANY_CONTENT })))); });
